// extracted by mini-css-extract-plugin
module.exports = {"button":"NewButton_button__3o3Dc","disabled":"NewButton_disabled__2vsRF"};